import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import SEO from '../../components/common/SEO';
import Breadcrumb from '../../components/common/Breadcrumb';

const NotFound = () => {
    return (
        <>
            <SEO 
                title="404 - Page Not Found | Arvix Creative"
                description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Return to Arvix Creative homepage."
                url="https://arvixcreative.com/404"
                noindex={true}
                nofollow={true}
            />
            <div className="min-h-screen px-4 pt-24 pb-20">
            <Breadcrumb items={[{ label: "Page Not Found" }]} className="mb-8" />
            <div className="flex items-center justify-center min-h-[60vh]">
            <div className="text-center">
                <h1 className="text-7xl sm:text-8xl md:text-9xl font-display font-bold text-designer-primary mb-6">404</h1>
                <h2 className="text-2xl sm:text-3xl font-bold text-designer-dark mb-4">Page Not Found</h2>
                <p className="text-gray-600 mb-8 max-w-md mx-auto">
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
                <Link 
                    to="/" 
                    className="px-6 py-3 bg-designer-primary text-white rounded-full font-medium hover:bg-designer-primary/90 transition-all inline-flex items-center"
                >
                    <FaHome className="mr-2" /> Back to Home
                </Link>
            </div>
            </div>
        </div>
        </>
    );
};

export default NotFound;